export enum IncomingThirdPartyName {
    bricks = 'bricks',
    caro = 'caro',
    chipsoft = 'chipsoft',
    dgtlHealth = 'dgtlHealth',
    ectosense = 'ectosense',
    embloom = 'embloom',
    evidencio = 'evidencio',
    fysiologic = 'fysiologic',
    healthconnected = 'healthconnected',
    healthConnectedFundusNisIntegration = 'healthConnectedFundusNisIntegration',
    interapy = 'interapy',
    medicom = 'medicom',
    medikit = 'medikit',
    microhis2 = 'microhis2',
    mira = 'mira',
    nsi = 'nsi',
    omnihis = 'omnihis',
    optoconnect = 'optoconnect',
    promedico = 'promedico',
    sanday_his = 'sanday_his',
    teledia = 'teledia',
    testHisKsyos = 'test-his-ksyos',
    tetrahis = 'tetrahis',
    unknown = 'unknown',
    zorgDomein = 'zorgDomein',
    zorgdossier = 'zorgdossier',
}
